<template>
  <div>
    <v-text-field
        v-model="tempValue"
        :label="label"
        clearable
        append-icon="add"
        mb-0
        class="green-add-icon"
        @click:append="add"
        @click:clear="clear"
        @keydown.native.enter="add" />
    <div
        v-if="items && items.length > 0"
        ma-0
        pa-0
        class="text-left">
      <v-chip
          v-for="(item, index) in items"
          :key="index"
          v-model="chips[index]"
          close
          class="v-chip--select-multi"
          :title="item"
          @click:close="onClose(index)">
        {{ item.substring(0,25) + ' ...' }}
      </v-chip>
    </div>
  </div>
</template>

<style scoped>
.green-add-icon::v-deep .v-input__icon--append button {
  color: var(--v-primaryiconbtn-base)!important;
}
</style>

<script>
  export default {
    props: {
      value: Array,
      label: String
    },
    data () {
      return {
        tempValue: null,
        items: [],
        chips: []
      }
    },
    methods: {
      add: function () {
        if (this.tempValue && this.tempValue.trim()) {
          this.items.push(this.tempValue)
          this.chips.push(true)
          this.$emit('input', this.items)
          this.tempValue = null
        } else {
          this.tempValue = null
        }
      },
      clear: function () {
        if (this.tempValue) {
          this.tempValue = null
        } else {
          this.items = []
          this.chips = []
          this.$emit('input', [])
        }
      },
      onClose: function (index) {
        this.items.splice(index, 1)
        this.chips.splice(index, 1)
        this.$emit('input', this.items)
      }
    }
  }
</script>
